module.exports = __webpack_public_path__ + "deefebe6293efe64cfae5c6d12657d53.svg";